import styled, { css } from "styled-components";
import { breakpoints } from "../../../../../ui/_utils/styleUtils";

export const Buttons: any = styled.div`
  flex: 0 0 auto;
  width: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-items: center;
  flex-direction: column;

  /* Change justify value based on the button count so single button gets centered */
  ${({ buttonCount }: { buttonCount: number }) => css`
    @media (min-width: ${breakpoints.xsmall + "px"}) {
      white-space: nowrap;
      flex-direction: row;
      justify-content: ${buttonCount > 1 ? "space-between" : "space-around"};
    }
  `};
`;
